export default class Analytics {
  static send = (data: any) => {
    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({
        ...data,
      });
    }
  };
}
